import { Component, useEffect } from "react";
import Lenis from "lenis";
import "./App.css";
import { LangProvider } from "./components/LangContext";
import { SettingsProvider } from "./components/SettingsContext";
import { setLenis } from "./scroll";
import AdminApp from "./admin/AdminApp";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import WhyMDR from "./components/WhyMDR";
import Experience from "./components/Experience";
import Games from "./components/Games";
import Systems from "./components/Systems";
import Esports from "./components/Esports";
import Branches from "./components/Branches";
import Prefer from "./components/Prefer";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFab from "./components/WhatsAppFab";
import { HomepageMetadata } from "./components/HomepageMetadata";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(e) {
    return { err: e };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="err-fallback" data-testid="error-boundary">
          <p>Bir şeyler ters gitti. / Something went wrong.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Site() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <>
      <HomepageMetadata />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <WhyMDR />
        <Experience />
        <Games />
        <Systems />
        <Esports />
        <Branches />
        <Prefer />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </>
  );
}

export default function App() {
  if (window.location.pathname.startsWith("/admin")) {
    return <AdminApp />;
  }
  return (
    <ErrorBoundary>
      <LangProvider>
        <SettingsProvider>
          <Site />
        </SettingsProvider>
      </LangProvider>
    </ErrorBoundary>
  );
}
